import styled from "styled-components";
import {Link} from "react-router-dom";

const PageHeadingLink = styled(Link)`
  margin-right: 10px;
  text-decoration: none;
  color: #000000;
  border-bottom: 1px solid #ffffff;

  &:hover {
    border-bottom: 1px solid #676767;
  }

`;

export default PageHeadingLink;